import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import Button from "../../../components/essentials/button/Button";
import LoadingSpinner from "../../../components/essentials/loading-spin/LoadingSpinner";
import { selectUser } from "../../../core/auth/authSlice";
import AuthApiRoutes from "../../../shared/api-routes/auth/auth.api-routes";
import http from "../../../shared/utils/http";
import "./SignUpConfirmation.scss";

const SignUpConfirmation: React.FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { userId, email } = useSelector(selectUser) || {};
  useEffect(() => {
    !email && navigate("login");
  });

  const resendMail = () => {
    setLoading(true);
    http.post(AuthApiRoutes.RESEND_VERIFICATION_MAIL, { email }).then(() => {
      setLoading(false);
      // window.location.reload();
    });
  };

  const [loading, setLoading] = useState<boolean>(false);

  return (
    <div className="sign-up-confirmation">
      <p className="sign-up-confirmation__caption">
        {t("signUp.codeConfirmationSection.title", { email })}
      </p>
      <div className="sign-up-confirmation__content">
        {loading ? (
          <LoadingSpinner />
        ) : (
          <Button className="btn btn-primary" action={resendMail}>
            Resend Mail
          </Button>
        )}
      </div>
    </div>
  );
};

export default SignUpConfirmation;
